export function isAccessGroupConnected(group) {
  return group.connection_status === 'ACTIVE' && group.connection_unusable !== true
}

export function splitAccessGroups(groups = []) {
  const pending = []
  const approved = []
  for (const group of groups) {
    if (isAccessGroupConnected(group)) approved.push(group)
    else pending.push(group)
  }
  return { pending, approved }
}

export function connectCardActivity(groups = []) {
  if (!groups.length) return 'connect'
  const connected = groups.filter(isAccessGroupConnected).length
  if (connected === groups.length) return 'success'
  if (connected > 0) return 'automation'
  return 'connect'
}
